export default (axios, resource, apiParams) => ({
    getAll(params) {
        return axios.get(`${resource}`, {params, ...apiParams});
    },
    find(id, params) {
        return axios.get(`${resource}/${id}`, {params, ...apiParams});
    },
    create(data, params) {
        return axios.post(`${resource}`, data, {params, ...apiParams});
    },
    update(id, data, params) {
        return axios.put(`${resource}/${id}`, data, {params, ...apiParams});
    },
    delete(id, params) {
        return axios.delete(`${resource}/${id}`, {params, ...apiParams});
    },
});